import React from 'react';

const ErrorFile = ({ responseFileName }) => {
  return <p>{responseFileName}</p>;
};

export default ErrorFile;
